import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Save, Building } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function AdminSettings() {
    const [settings, setSettings] = useState({ company_name: "", org_number: "", address: "", phone: "", email: "" });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        api.get("/settings/company").then((r) => setSettings(r.data)).catch(console.error).finally(() => setLoading(false));
    }, []);

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            const res = await api.put("/settings/company", settings);
            setSettings(res.data);
            toast.success("Företagsuppgifter sparade");
        } catch { toast.error("Kunde inte spara"); }
        finally { setSaving(false); }
    };

    if (loading) return <div className="p-8 text-neutral-400">Laddar...</div>;

    return (
        <div className="p-8" data-testid="admin-settings">
            <h1 className="text-2xl font-medium tracking-tight mb-6">Inställningar</h1>
            <Card className="bg-white border-neutral-200 shadow-none rounded-md max-w-2xl">
                <CardHeader className="pb-3">
                    <CardTitle className="text-sm uppercase tracking-wider text-neutral-500 flex items-center gap-2">
                        <Building size={16} /> Företagsuppgifter
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <p className="text-xs text-neutral-400 mb-6">Dessa uppgifter visas på offerter och kommunikation.</p>
                    <form onSubmit={handleSave} className="space-y-4">
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <Label className="text-xs uppercase tracking-wider">Företagsnamn</Label>
                                <Input data-testid="company-name" value={settings.company_name || ""} onChange={(e) => setSettings({ ...settings, company_name: e.target.value })} className="mt-1" />
                            </div>
                            <div>
                                <Label className="text-xs uppercase tracking-wider">Org.nummer</Label>
                                <Input data-testid="company-org" value={settings.org_number || ""} onChange={(e) => setSettings({ ...settings, org_number: e.target.value })} className="mt-1" />
                            </div>
                        </div>
                        <div>
                            <Label className="text-xs uppercase tracking-wider">Adress</Label>
                            <Input data-testid="company-address" value={settings.address || ""} onChange={(e) => setSettings({ ...settings, address: e.target.value })} className="mt-1" />
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <Label className="text-xs uppercase tracking-wider">Telefon</Label>
                                <Input data-testid="company-phone" value={settings.phone || ""} onChange={(e) => setSettings({ ...settings, phone: e.target.value })} className="mt-1" />
                            </div>
                            <div>
                                <Label className="text-xs uppercase tracking-wider">E-post</Label>
                                <Input data-testid="company-email" value={settings.email || ""} onChange={(e) => setSettings({ ...settings, email: e.target.value })} className="mt-1" />
                            </div>
                        </div>
                        <Button data-testid="save-settings-btn" type="submit" disabled={saving} className="bg-black text-white hover:bg-neutral-800">
                            <Save size={14} className="mr-2" /> {saving ? "Sparar..." : "Spara uppgifter"}
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}
